import { type GetServerSideProps } from 'next';

import { SuccessTemplate } from '../templates';

import { staticContent } from '../data/seja-um-profissional';
import { withEnhancedPageHandler } from '../middlewares/withEnhancedPageHandler';

const SuccessPage = (props) => <SuccessTemplate {...props} />;

const getServerSidePropsHandler: GetServerSideProps = async ({ query }) => {
  const deepLink =
    (query.deep_link as string) || 'https://www.getninjas.com.br/download/app';
  const regexAllowOrigin =
    /https:\/\/(www|blog|site-profissionais|site-clientes)(-smoke|-jade|-goro)?.getninjas(-homolog)?\.(com|dev)\.?(br|mx)?/;

  if (!deepLink.match(regexAllowOrigin)) {
    return {
      notFound: true,
    };
  }

  return {
    props: {
      staticContent,
      buttonLink: deepLink,
    },
  };
};

export const getServerSideProps = withEnhancedPageHandler(
  getServerSidePropsHandler
);

export default SuccessPage;
